var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusyBeeActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_186",
    "data-name": "Group 186",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78.948,
    height: 69.595,
    viewBox: "0 0 78.948 69.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 78.948,
    height: 69.595,
    fill: "#ed3a72"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    d: "M96.247,252.285c0,.924.017,1.755,0,2.586a11.4,11.4,0,0,1-.745,3.721,7.917,7.917,0,0,1-4.969,4.9,13.017,13.017,0,0,1-7.446.366c-3.664-.867-6.136-3.88-6.616-7.927a12.158,12.158,0,0,1-.067-2.987c.073-.566-.095-.556-.528-.377-2.328.963-4.583,2.08-6.825,3.224a66.476,66.476,0,0,0-16.823,11.543c-.718.707-1.5,1.354-2.214,2.088.136-.191.265-.388.408-.572A65.691,65.691,0,0,1,65.955,254.7a67.9,67.9,0,0,1,9.374-5.378,1.519,1.519,0,0,0,.811-.847c3.3-7.75,13.408-7.73,17.917-3.525a11.517,11.517,0,0,1,2.558,3.655,1.378,1.378,0,0,0,.694.694,77.117,77.117,0,0,1,19.7,13.693,49.443,49.443,0,0,1,5.641,6.447.467.467,0,0,1,.089.256c-7.323-8.086-16.67-13.06-26.5-17.412",
    transform: "translate(-46.838 -226.772)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    d: "M779.8,428.394a.452.452,0,0,1,.4.075,100.6,100.6,0,0,1,15.663,9.551,36.443,36.443,0,0,1,9.709,10.459,13.778,13.778,0,0,1,1.747,4.187,2.44,2.44,0,0,1-1.857,3.247,10.959,10.959,0,0,1-5.383.2,22.7,22.7,0,0,1-5.185-1.6c-.206-.086-.414-.166-.644-.257a12.813,12.813,0,0,1-.653,2.189,1.857,1.857,0,0,1-2.715,1.1,11.252,11.252,0,0,1-3.689-2.511,30.092,30.092,0,0,1-6.725-10.217,62.31,62.31,0,0,1-2.6-7.8,1.164,1.164,0,0,1,.142-1.012,12.519,12.519,0,0,0,1.789-7.153c0-.154,0-.308,0-.457",
    transform: "translate(-728.473 -401.197)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    "data-name": "Path 3943",
    d: "M27.622,430.869a12.238,12.238,0,0,0,1.683,5.8,1.737,1.737,0,0,1,.2,1.462,45.944,45.944,0,0,1-5.375,12.954,20.4,20.4,0,0,1-6.483,6.774c-2.3,1.4-3.553.851-4.179-1.763-.25-1.045-.25-1.045-1.269-.61a17.943,17.943,0,0,1-7.439,1.687,9.144,9.144,0,0,1-2.743-.447,2.5,2.5,0,0,1-1.873-3.417A15.856,15.856,0,0,1,2.15,448.86a37.9,37.9,0,0,1,9.539-10.075A92.889,92.889,0,0,1,24.844,430.6c.721-.381,1.457-.735,2.17-1.131.451-.25.752-.38.617.362a6.681,6.681,0,0,0-.008,1.042",
    transform: "translate(0 -402.037)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3944",
    "data-name": "Path 3944",
    d: "M380.334,16.267A5.372,5.372,0,0,1,381.7,9.879a7.206,7.206,0,0,1,1.737-1.185c.331-.158.443-.316.226-.663-.373-.6-.713-1.211-1.062-1.821a1.415,1.415,0,0,0-.659-.562q-3.758-1.834-7.51-3.683c-.082-.04-.165-.075-.247-.115q-1.132-.555-.74-1.364c.258-.532.76-.635,1.524-.265,2.693,1.3,5.379,2.621,8.072,3.924a2.082,2.082,0,0,1,.914.879c.476.825.972,1.638,1.432,2.472a.507.507,0,0,0,.7.282,10.855,10.855,0,0,1,6.108-.005c.431.123.633.006.781-.365a7.891,7.891,0,0,1,4.871-4.573c1.8-.679,3.481-1.648,5.216-2.486,1.039-.5,1.474-.47,1.756.124.292.614.04,1-.961,1.488-2.2,1.068-4.388,2.173-6.614,3.19a4.159,4.159,0,0,0-2.153,2.02c-.6,1.217-.656,1.189.486,1.931a5.717,5.717,0,0,1,2.642,6.623c-.138.45-.272.532-.675.223a14.171,14.171,0,0,0-16.707-.01c-.158.122-.336.218-.507.327",
    transform: "translate(-349.662 0.001)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3945",
    "data-name": "Path 3945",
    d: "M433.391,754a21.548,21.548,0,0,1-11.247-2.893c-1.833-1.1-1.826-1.122-1.112-3.105.183-.509.273-1.269.63-1.437.379-.178.883.465,1.36.7,7.353,3.666,14.6,3.59,21.714-.64.391-.232.507-.2.638.218.25.8.516,1.6.836,2.371a.822.822,0,0,1-.365,1.13,19.16,19.16,0,0,1-7.719,3.21,22.514,22.514,0,0,1-4.734.443",
    transform: "translate(-393.906 -699.132)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3946",
    "data-name": "Path 3946",
    d: "M460.554,615.164a11.675,11.675,0,0,0,4.749,2.371,15.539,15.539,0,0,0,11.6-1.37c.138-.078.271-.165.4-.253.972-.645.951-.639,1.291.46a29.615,29.615,0,0,0,1.039,3.019c.3.685.106.961-.5,1.3a20.857,20.857,0,0,1-19.589-.065c-.493-.273-.616-.533-.394-1.066a30.141,30.141,0,0,0,1.4-4.393",
    transform: "translate(-429.928 -576.141)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3947",
    "data-name": "Path 3947",
    d: "M406.71,847.653c6.824,5.669,19.655,6.156,27.354.023.085,1.745-.011,3.309-1.582,4.445a20.859,20.859,0,0,1-23.924.185c-1.678-1.15-1.992-2.727-1.848-4.653",
    transform: "translate(-380.881 -793.882)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3948",
    "data-name": "Path 3948",
    d: "M454.078,975.36c7.161,4.18,14.3,4.054,21.486-.1a11.905,11.905,0,0,1-2.358,3.3,14.455,14.455,0,0,1-7.126,4.278,6.6,6.6,0,0,1-3.742-.281,15.156,15.156,0,0,1-8.17-6.827c-.063-.1-.182-.214-.091-.365",
    transform: "translate(-425.242 -913.393)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3949",
    "data-name": "Path 3949",
    d: "M331.351,242.384c-.7.359-1.3.656-1.895.983-.266.147-.419.056-.571-.151a28.56,28.56,0,0,1-3.416-5.865,2.026,2.026,0,0,1-.128-.458c-.043-.272-.087-.607.191-.737.3-.142.405.208.539.4a39.2,39.2,0,0,0,4.722,5.351c.16.156.338.293.557.482",
    transform: "translate(-304.673 -221.143)",
    fill: "#ed3a72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3950",
    "data-name": "Path 3950",
    d: "M834.438,237.148c-.066.184-.173.556-.329.906a29.588,29.588,0,0,1-3.043,5.214c-.283.393-.543.572-.981.222a3.915,3.915,0,0,0-.652-.362c-.943-.491-.942-.489-.185-1.2a39.58,39.58,0,0,0,4.5-5.174c.131-.174.243-.441.519-.33.209.084.231.317.171.721",
    transform: "translate(-776.132 -221.405)",
    fill: "#ed3a72"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusyBeeActive);
export default __webpack_public_path__ + "static/media/busy-bee-active.3bbe4f20db9993ebd419a8547c874dd2.svg";
export { ForwardRef as ReactComponent };